import { render, staticRenderFns } from "./SuggestImage.vue?vue&type=template&id=ce7ad1a6&scoped=true&"
import script from "./SuggestImage.vue?vue&type=script&lang=js&"
export * from "./SuggestImage.vue?vue&type=script&lang=js&"
import style0 from "./SuggestImage.vue?vue&type=style&index=0&id=ce7ad1a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7ad1a6",
  null
  
)

export default component.exports